.state {
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md, 16px);
  padding: calc(var(--space-lg, 24px) + var(--inset-top, 0px)) var(--space-lg, 24px) var(--space-lg, 24px);
  text-align: center;
}

.title {
  font-size: 28px;
  line-height: 1.1;
}

.text {
  color: var(--muted);
  max-width: 32ch;
}

.btn {
  border: 0;
  border-radius: 999px;
  padding: 12px 26px;
  font-weight: 500;
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
  box-shadow:
    0 0 0 1px var(--fill-ring),
    0 8px 20px var(--fill-glow);
}
